import { AfterViewInit, ChangeDetectorRef, Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AbstractControl, FormArray, UntypedFormControl, UntypedFormGroup, ValidatorFn } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { RegistrationService, ValidationStatuses } from '../../services';
import { RegistrationTypes } from '../../../shared/models/registrationType.enum';
import { BcMessagesManager } from '../../../widgets';


@Component({
  selector: 'bc-reg-origin-of-assets',
  templateUrl: './reg-origin-of-assets.component.html',
  styleUrls: ['./reg-origin-of-assets.component.scss']
})
export class RegOriginOfAssetsComponent implements OnInit, AfterViewInit {

  pageStructure: Array<NavItem>;
  pageTitle: string;
  activePageIdx: number;
  root: TreeRoot;
  isLE = false;

  form: UntypedFormGroup = new UntypedFormGroup({});

  get isFirstParty() {
    return this.registrationService.isFirstParty;
  }

  constructor(
    public registrationService: RegistrationService,
    private cd: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    @Inject(LOCALE_ID) public locale: string,
    private router: Router,
    private toastr: ToastrService,
    public bcMessagesManager: BcMessagesManager) {
  }

  ngOnInit() {
    this.root = this.registrationService.root;
    this.isLE = (this.registrationService.registrationType === 'BUSINESS');
    this.pageStructure = this.isLE ?
      this.registrationService.getLePageStructure(this.registrationService.party._id) :
      this.registrationService.getNpPageStructure(this.registrationService.party._id);

    const pageId = this.activatedRoute.snapshot.data['pageId'];
    this.activePageIdx = this.pageStructure.findIndex((page: NavItem) => page.id === pageId);
    this.pageTitle = this.registrationService.getPageName(this.pageStructure, pageId);
    this.registrationService.setActivePage(this.pageStructure, pageId);

    this.initForm();
    this.populateForm();
  }

  initForm() {
    const controls: Array<AbstractControl> = [];
    const origins = this.registrationService.workflow.originOfAssets.origins;
    origins.forEach(origin => {
      const group = new UntypedFormGroup({
        id: new UntypedFormControl(origin.id),
        name : new UntypedFormControl(origin.name[this.locale]),
        value : new UntypedFormControl(false)
      });
      controls.push(group);
    });

    this.form.addControl('originOfAssets', new FormArray(controls, this.validateOriginOfAssets()));
  }

  validateOriginOfAssets(): ValidatorFn {
    return (formArray: FormArray): {[key: string]: any} | null => {
      let valid = false;
      formArray.controls.forEach((item: UntypedFormGroup) => {
          if (item.value.value) valid = true;
      });

      return valid ? null : { error: 'No option selected' };
    };
  }

  populateForm() {
    if (this.root && this.root.originOfAssets) {
      this.root.originOfAssets.forEach(origin => {
        (this.form.get('originOfAssets') as FormArray).controls.forEach((control: UntypedFormGroup) => {
          if (control.get('id').value === origin.id) {
            control.get('value').setValue(true);
          }
        });
      });
    }
  }

  ngAfterViewInit() {
    this.registrationService.updateTaskStatus(this.pageStructure, this.registrationService.party, this.isFirstParty);
    this.cd.detectChanges();
  }

  proceed() {
    this.registrationService.setPartyToRoot(this.registrationService.party);

    let origins = this.form.value.originOfAssets.filter(item => item.value).map((item: any) => ({id: item.id}));
    origins = {originOfAssets: origins};

    this.registrationService.updateOriginOfAssets(origins)
      .then(() => {
        this.pageStructure[this.activePageIdx].status$.next(ValidationStatuses.Done);
        switch (this.registrationService.registrationType) {
          case RegistrationTypes.INDIVIDUAL:
          case RegistrationTypes.JOINT:
              this.router.navigate(['/']);
            break;

          case RegistrationTypes.BUSINESS: {
            let redirect = ['/'];
            this.registrationService.root.parties[0].parties
              .some((party: any) => {
                if (this.registrationService.npCompleted.get(party._id) !== ValidationStatuses.Done) {
                  redirect = ['/structure/parties-overview'];

                  return true;
                }
              });

            this.router.navigate(redirect);
            break;
          }

          default:
            console.error('Invalid registration type');
        }
      }).catch(() => {
        this.toastr.error(this.bcMessagesManager.translations['ERROR']);
      });
  }

}
